export default "__VITE_ASSET__BCYPqTzM__"